import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./InfoGridText.module.css";
import CTAPopUp from "../CtaPopUp";
import arrow from "../../assets/icons/arrow-right-02.svg";

const InfoGridText = (props: any) => {
  const { data, isSchool } = props;
  const [btnClick, setBtnClick] = useState<any>({});

  const desc = data?.description?.content?.[0]?.content?.[0]?.text;

  return (
    <>
    {
      data && (
    <div
      className="container main_padding infogrid-text-right"
      data-testid="infog-container-id"
    >
      <div className="row">
        <div className="col-12 col-md-6 mb-4 mb-lg-0">
          <div className={` ${styles.card}`}>
            {data?.relatedmedia?.results?.[0]?.fileUrl && (
             <Image
              src={data?.relatedmedia?.results?.[0]?.fileUrl}
              alt={"relatedmedia"}
              width={400}
              height={0}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              data-testid="image-0"
            />
              )}
            
            <div className={` ${styles.overlay}`}></div>
            {data?.icon?.results?.length > 0 && (
              <div className={styles.overlayText}>
                <div className={styles.imageContainer}>
                  <Image
                    src={data?.icon?.results?.[0]?.fileUrl}
                    alt={"icon"}
                    width={56}
                    height={56}
                    data-testid="icon-0"
                  />
                </div>
                <div className={styles.textContainer}>
                  <span data-testid="title-0">{data?.title}</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className={styles.curriculum_wrap}>
            {data?.title && <h1>{data?.title}</h1>}
            {data?.summary && <p>{data?.summary}</p>}
          </div>

          <div className={`${styles.Curriculum_desc} curriculum_ul`}>
            <p dangerouslySetInnerHTML={{ __html: desc }} />
            {data?.link?.results?.length > 0 && (
              <div className={styles.rightarrow}>
                {isSchool ? (
                  <a data-bs-toggle="modal" data-bs-target="#exampleModal1">
                    <span>{data?.link?.results?.[0]?.name}</span>
                    <Image
                      src={
                        data?.link?.results?.[0]?.icon?.results?.[0]?.fileUrl ||
                        arrow
                      }
                      height={24}
                      width={24}
                      alt="arrow"
                    />
                  </a>
                ) : (
                  <Link
                    href={data?.link?.results?.[0]?.hyperlink}
                    target={
                      data?.link?.results?.[0]?.externallink === true
                        ? "_blank"
                        : ""
                    }
                  >
                    <span>{data?.link?.results?.[0]?.name}</span>
                    <Image
                      src={
                        data?.link?.results?.[0]?.icon?.results?.[0]?.fileUrl ||
                        arrow
                      }
                      height={24}
                      width={24}
                      alt="arrow"
                    />
                  </Link>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <CTAPopUp data={btnClick} />
    </div>
     )}
    </>
  );
};

export default InfoGridText;
